import { useEffect, useRef, useState } from "react";
import Carousel from "./carousel/carousel";
import {Collapse} from "bootstrap" ;
import {Link} from "react-router-dom" ;
import {ReactComponent as ArrowRightIcon} from "../../../assets/icons/arrow-right.svg" ;

import "./how-it-works.scss" ;
import { CHOOSE_PLAN_ROUTE, CONTACT_US } from "../../../routes";

const HowItWorksSection = (props) => {

    const [currentStep,setCurrentStepState] = useState(0) ;
    let collapse1 = useRef();
    let collapse2 = useRef();
    let collapse3 = useRef();
    let collapse4 = useRef();
    const [allCollapse,setAllCollapse] = useState(0) ;

    const setCurrentStep = (index) => {
        allCollapse.forEach((c,i) => {
            if(i === index)
                c.show()
            else
                c.hide()
        })
        setCurrentStepState(index);
    }

    useEffect(()=>{
        let temp = [];
        temp.push(new Collapse(collapse1.current,{toggle : false }));
        temp.push(new Collapse(collapse2.current,{toggle : false }));
        temp.push(new Collapse(collapse3.current,{toggle : false }));
        temp.push(new Collapse(collapse4.current,{toggle : false }));
        setAllCollapse(temp);
    },[])


    return (
        <section ref={props.anchor} id="how-it-works-section">
            <div className="container-sm px-3 px-md-3" style={{ padding: "8rem 0" }}>
                <h1 className="text-center text-secondary">How it Works</h1>
                <p className="text-center text-black-50 mt-5">
                    We have identified all the compliance points under the
                    Property & Stock Agents Act 2002. We’ve been back and
                    reviewed hundreds of agent’s audits. We know what the
                    authorities are looking for. We’ve automated it. We’ve made
                    it affordable. We’ve made it so easy to use.
                </p>
                <div className="row mt-5 mx-auto w-100 gy-5 gx-0 gx-md-5 p-0">
                    <div className="col-lg left-section" id="#howitworks">
                        <div className="my-4">
                            <div className="header cursor-pointer" onClick={()=>setCurrentStep(0)}>
                                {
                                    (currentStep === 0) ? (
                                        <>
                                        <h4 className="text-secondary">Step 1.</h4>
                                        <h2 className="text-primary">Create an Account</h2>
                                        </>
                                    ) :
                                        <>
                                        <h4 className="text-3">Step 1. Create an Account</h4>
                        
                                        </>
                                }
                            </div>
                            <div ref={collapse1} className="collapse show text-body-1 text-2">
                                It’s simple. Create an account using your business details and the person most 
                                likely to look after the compliance monitoring in your business. (You can always 
                                change this person later on).
                            </div>
                        </div>

                        <div className="my-4">
                            <div className="header cursor-pointer" onClick={()=>setCurrentStep(1)}>
                                {   
                                    (currentStep === 1) ? (
                                        <>
                                        <h4 className="text-secondary">Step 2.</h4>
                                        <h2 className="text-primary">Select your plan</h2>
                                        </>
                                    ) :
                                        <>
                                        <h4 className="text-3">Step 2. Select your plan</h4>
                        
                                        </>
                                }
                            </div>
                            <div ref={collapse2} className="collapse text-body-1 text-2">
                                Once your account is in place, select your plan based on the number of staff the    
                                business currently has .
                            </div>
                        </div>

                        <div className="my-4">
                            <div className="header cursor-pointer" onClick={()=>setCurrentStep(2)}>
                                {
                                    (currentStep === 2) ? (
                                        <>
                                        <h4 className="text-secondary">Step 3.</h4>
                                        <h2 className="text-primary">Choose payment</h2>
                                        </>
                                    ) :
                                        <>
                                        <h4 className="text-3">Step 3. Choose payment</h4>
                        
                                        </>
                                }
                            </div>
                            <div ref={collapse3} className="collapse text-body-1 text-2">
                                Set up your secure payment method. We use Stripe as our payment gateway. Your 
                                temporary password will be emailed to you and you can now finalise your account 
                                details.
                            </div>
                        </div>

                        <div className="my-4">
                            <div className="header cursor-pointer" onClick={()=>setCurrentStep(3)}>
                                {
                                    (currentStep === 3) ? (
                                        <>
                                        <h4 className="text-secondary">Step 4.</h4>
                                        <h2 className="text-primary">Welcome to iComply</h2>
                                        </>
                                    ) :
                                        <>
                                        <h4 className="text-3">Step 4. Welcome to iComply</h4>
                        
                                        </>
                                }
                            </div>
                            <div ref={collapse4} className="collapse text-body-1 text-2">
                                Start your compliance. Enter the requested information about your business and staff into our easy to use compliance template. Enjoy your compliance.
                            </div>
                        </div>

                        <div className="links">
                            <Link to={CHOOSE_PLAN_ROUTE} className="d-block" style={{textDecoration:"none"}} >
                                <h6 className="text-primary">GET STARTED <ArrowRightIcon height="1rem"/></h6>
                            </Link>
                            <hr className="text-primary" style={{width : "16rem"}}/>
                            <Link to={CONTACT_US} className="d-block" style={{textDecoration:"none"}} >
                                <h6 className="text-primary text-nowrap">NEED MORE INFO <ArrowRightIcon height="1rem"/></h6>
                            </Link>
                        </div>
                        
                    </div>
                    <div className="col-lg d-flex align-items-center">
                        <Carousel setCurrentStep={setCurrentStep} currentStep={currentStep} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
